import { CarouselProps } from '@landr/maestro';

export const NB_PACKS_BY_CAROUSEL = 12;

export const packCardsPerPage: CarouselProps['slidesPerPage'] = {
    xs: 2,
    sm: 3,
    md: 4,
    lg: 5,
    xl: 6,
    default: 6,
};
